import '@abraham/reflection';
import { injectable, inject, singleton, container } from 'tsyringe-neo';
import { uniq, omit } from 'ramda';
import emittery from 'emittery';
import { request, createBaseRequest, setBaseRequest } from '@linkpi/request';
import { match, P } from 'ts-pattern';
import { buildMap } from '@linkpi/utils';
import { v4 } from 'uuid';
import { handleFilterReqParam } from '@linkpi/core';

var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
var __publicField$5 = (obj, key, value) => {
  __defNormalProp$5(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let PiConnectionManager = class {
  constructor() {
    __publicField$5(this, "PiConnectionMap", /* @__PURE__ */ new Map());
  }
  addPiConnection(orgId, piConnection) {
    this.PiConnectionMap.set(orgId, piConnection);
  }
  getPiConnection(orgId) {
    return this.PiConnectionMap.get(orgId);
  }
};
PiConnectionManager = __decorateClass$b([
  injectable()
], PiConnectionManager);

var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
let EventManager = class extends emittery {
};
EventManager = __decorateClass$a([
  injectable()
], EventManager);

const parseToArray = (s, splitChar = ",") => s ? uniq(s.split(splitChar).filter(Boolean)) : [];
const handleUserList = (list) => list.map((u) => ({
  ...u,
  group_ids: u.group_ids?.filter?.(Boolean) || [],
  // 注意标点，是顿号 、
  group_list: parseToArray(u.group_list, "\u3001").join("\u3001"),
  org_struct_ids: parseToArray(u.org_struct_ids),
  org_struct_ids_all: parseToArray(u.org_struct_ids_all),
  // 注意标点，是顿号 、
  org_struct_list: parseToArray(u.org_struct_list, "\u3001"),
  // 注意标点，是顿号 、
  org_struct_list_all: parseToArray(u.org_struct_list_all, "\u3001"),
  org_struct_role: parseToArray(u.org_struct_role).map(
    (i) => Number(i)
  ),
  org_struct_role_all: parseToArray(u.org_struct_role_all).map(
    (i) => Number(i)
  )
}));
const formatMetaDataToNodeData = (m) => {
  const propValues = m.e?._sys_temp?.[1] || [];
  if (m.e?._sys_attach) {
    Object.keys(m.e._sys_attach).forEach((key) => {
      const nameList = match(propValues[key]).with(P.array(P.string), (v) => v).otherwise(() => []);
      const urlList = m.e._sys_attach[key];
      const fileList = nameList.map((name, index) => ({
        name,
        url: urlList[index]
      }));
      propValues[key] = fileList;
    });
  }
  if (m.e?._sys_location) {
    Object.keys(m.e._sys_location).forEach((key) => {
      propValues[key] = m.e._sys_location[key];
    });
  }
  return {
    id: m.n,
    title: m.t,
    creator: m.i,
    createTime: m.h,
    updateTime: m.m,
    templateId: m.e?._sys_temp?.[0] || "FF",
    propValues,
    status: m.e?._sys_task_status?.index || 0,
    statusPropValues: m.e?._sys_task_status?.prop || []
  };
};

const getCurrentUser = ({ orgId }) => {
  return request("/api/currentUser", {
    data: { templates: [orgId] }
  }).then((res) => res.status === "ok" ? res.data : Promise.reject(res));
};
const getUserList = async (params) => {
  return request("/api/organization/user", {
    method: "POST",
    data: params
  }).then(
    (res) => res.status === "ok" ? handleUserList(res.data) : Promise.reject(res)
  );
};

var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
var __decorateParam$8 = (index, decorator) => (target, key) => decorator(target, key, index);
var __publicField$4 = (obj, key, value) => {
  __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let CurrentUserManager = class {
  constructor(eventManager) {
    this.eventManager = eventManager;
    __publicField$4(this, "currentUser");
  }
  async updateCurrentUser({ orgId }) {
    const currentUser = await getCurrentUser({
      orgId
    });
    this.currentUser = omit(["organization"], currentUser);
    this.eventManager.emit("currentUserUpdate", { currentUser, orgId });
  }
};
CurrentUserManager = __decorateClass$9([
  injectable(),
  __decorateParam$8(0, inject(EventManager))
], CurrentUserManager);

var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
let GroupManager = class {
  constructor() {
  }
};
GroupManager = __decorateClass$8([
  injectable()
], GroupManager);

var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
var __decorateParam$7 = (index, decorator) => (target, key) => decorator(target, key, index);
let DepartmentManager = class {
  constructor(groupManager) {
    this.groupManager = groupManager;
  }
};
DepartmentManager = __decorateClass$7([
  injectable(),
  __decorateParam$7(0, inject(GroupManager))
], DepartmentManager);

var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
var __decorateParam$6 = (index, decorator) => (target, key) => decorator(target, key, index);
let RoleManager = class {
  constructor(groupManager) {
    this.groupManager = groupManager;
  }
};
RoleManager = __decorateClass$6([
  injectable(),
  __decorateParam$6(0, inject(GroupManager))
], RoleManager);

var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
var __decorateParam$5 = (index, decorator) => (target, key) => decorator(target, key, index);
var __publicField$3 = (obj, key, value) => {
  __defNormalProp$3(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let OrgManager = class {
  constructor(eventManager) {
    this.eventManager = eventManager;
    __publicField$3(this, "orgMap");
    this.eventManager.on("currentUserUpdate", this.updateAllOrgInfo);
  }
  updateAllOrgInfo({ currentUser }) {
    this.orgMap = buildMap(
      currentUser.organization.map((o) => omit(["templateList"], o)),
      "orgId"
    );
  }
  getOrgInfo(orgId) {
    return this.orgMap.get(orgId);
  }
};
OrgManager = __decorateClass$5([
  injectable(),
  __decorateParam$5(0, inject(EventManager))
], OrgManager);

var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
var __decorateParam$4 = (index, decorator) => (target, key) => decorator(target, key, index);
var __publicField$2 = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let UserManager = class {
  constructor(roleManager, departmentManager, eventManager) {
    this.roleManager = roleManager;
    this.departmentManager = departmentManager;
    this.eventManager = eventManager;
    __publicField$2(this, "userList", []);
  }
  async updateCurrentUser({ ad, token }) {
    const userList = await getUserList({
      avatar: true,
      ad,
      token
    });
    this.userList = userList;
    this.eventManager.emit("userListUpdate", userList);
  }
};
UserManager = __decorateClass$4([
  injectable(),
  __decorateParam$4(0, inject(RoleManager)),
  __decorateParam$4(1, inject(DepartmentManager)),
  __decorateParam$4(2, inject(EventManager))
], UserManager);

var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
var __decorateParam$3 = (index, decorator) => (target, key) => decorator(target, key, index);
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let TemplateManager = class {
  constructor(orgManager, userManager, departmentManager, roleManager, eventManager) {
    this.orgManager = orgManager;
    this.userManager = userManager;
    this.departmentManager = departmentManager;
    this.roleManager = roleManager;
    this.eventManager = eventManager;
    __publicField$1(this, "orgTemplatesMap", /* @__PURE__ */ new Map());
    this.eventManager.on("currentUserUpdate", this.updateOrgTemplates);
  }
  updateOrgTemplates({
    currentUser,
    orgId
  }) {
    const orgInfo = currentUser.organization.find((o) => o.orgId === orgId);
    const tempMap = buildMap(orgInfo.templateList, "template_id");
    this.orgTemplatesMap.set(orgId, tempMap);
  }
};
TemplateManager = __decorateClass$3([
  injectable(),
  __decorateParam$3(0, inject(OrgManager)),
  __decorateParam$3(1, inject(UserManager)),
  __decorateParam$3(2, inject(DepartmentManager)),
  __decorateParam$3(3, inject(RoleManager)),
  __decorateParam$3(4, inject(EventManager))
], TemplateManager);

var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
var __decorateParam$2 = (index, decorator) => (target, key) => decorator(target, key, index);
let NodeManager = class {
  constructor(templateManager, departmentManager, roleManager) {
    this.templateManager = templateManager;
    this.departmentManager = departmentManager;
    this.roleManager = roleManager;
  }
};
NodeManager = __decorateClass$2([
  injectable(),
  __decorateParam$2(0, inject(TemplateManager)),
  __decorateParam$2(1, inject(DepartmentManager)),
  __decorateParam$2(2, inject(RoleManager))
], NodeManager);

const CLOUD_FLAG = "$$CLOUD_FUNCTION$$";
const device_id = v4();
const baseRequest = createBaseRequest({});
const registerAuthToken = ({
  ad,
  token
}) => {
  baseRequest.interceptors.request.use((config) => {
    if (config.method && ["post", "put"].includes(config.method.toLocaleLowerCase())) {
      match(config.data).with({ [CLOUD_FLAG]: true, props: P.nonNullable }, (c) => {
        c.props = {
          device_id,
          ad,
          token,
          ...c.props
        };
        console.log(c.props);
      }).otherwise(() => {
        if (!config.data)
          config.data = {};
        if (typeof config.data === "object") {
          config.data.device_id = device_id;
          config.data.ad = ad;
          config.data.token = token;
        }
      });
    }
    return config;
  });
};
setBaseRequest(baseRequest);

async function getNodeList({
  conditionV2,
  group,
  orderBy,
  orderDesc,
  userId,
  orgId,
  temp_id
}) {
  const params = handleFilterReqParam(
    {
      recycle: false,
      temp_id: temp_id ?? null,
      keyWords: [],
      onlyTitle: false,
      org_id: orgId,
      tempProps: [],
      // ["p1-xxx", "s1-xxx", "si-1"]
      groupBy: [],
      filterTime: {}
    },
    [],
    null,
    { conditionV2, condition: [], group, orderBy, orderDesc },
    userId,
    userId
  );
  const res = await request("/docapi/getNodeByFilter", {
    method: "POST",
    data: params
  });
  if (res.status === "ok")
    return res.data;
  return Promise.reject(res);
}

const getTableList = (params) => {
  return request("/docapi/tableView/query", { method: "POST", data: params });
};
const addTableData = async (params) => {
  return request("/docapi/tableView/insert", {
    method: "POST",
    data: params
  });
};
const editTableData = async (params) => {
  return request("/docapi/tableView/update", {
    method: "POST",
    data: params
  });
};
const deleteTableData = async (params) => {
  return request("/docapi/tableView/delete", {
    method: "POST",
    data: params
  });
};
const getTableHeader = async (params) => {
  return request("/api/tableView/getHeader", {
    method: "POST",
    data: params
  });
};
const getTableHeaderMapList = async (params) => {
  return request("/api/tableHeaderMap/query", {
    method: "POST",
    data: params
  });
};
const getTableHeaderByTemplate = async (params) => {
  return request("/api/tableHeader/queryTemp", {
    method: "POST",
    data: params
  }).then((res) => {
    if (res.status === "ok")
      return res.data;
    throw res.err;
  });
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
var __decorateParam$1 = (index, decorator) => (target, key) => decorator(target, key, index);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
let TableHeaderManager = class {
  constructor(currentUserManager, orgManager) {
    this.currentUserManager = currentUserManager;
    this.orgManager = orgManager;
    __publicField(this, "query", ({
      page,
      pageSize,
      orgId,
      condition,
      view_id,
      thm_id
    }) => {
      return getTableList({
        limit: pageSize,
        offset: (page - 1) * pageSize,
        org_id: orgId,
        condition,
        view_id,
        thm_id
      });
    });
    __publicField(this, "queryByTemplate", async ({
      page,
      pageSize,
      orgId,
      condition
    }) => {
      const tempId = condition.find((i) => i.key === "templateId")?.input[0];
      if (!tempId)
        throw Error("tempId \u4E0D\u5B58\u5728");
      const { headerMap } = await getTableHeaderByTemplate({
        org_id: orgId,
        temp_id: tempId
      });
      const th_id = headerMap.thm_id;
      const sysPropMap = {};
      const propMap = {};
      const statusPropMap = {};
      Object.keys(headerMap.temp.header_map).forEach((key) => {
        const item = headerMap.temp.header_map[key];
        match(item).with({ type: "status" }, () => {
          sysPropMap["status"] = key;
        }).with({ type: "sys_prop", column: P.select() }, (column) => {
          sysPropMap[column] = key;
        }).with({ type: "prop", index: P.select() }, (index) => {
          propMap[index] = key;
        }).with({ type: "status_prop", index: P.select() }, (index) => {
          statusPropMap[index] = key;
        }).exhaustive();
      });
      const newConditionV2 = [];
      condition.forEach((c) => {
        const key = c.key;
        if (key === "prop") {
          const { index, ...rest } = c;
          newConditionV2.push({ ...rest, key: propMap[index] });
          return;
        }
        if (key === "statusProp") {
          const { index, ...rest } = c;
          newConditionV2.push({ ...rest, key: statusPropMap[index] });
          return;
        }
        if (key === "sysCreator") {
          newConditionV2.push({ ...c, key: sysPropMap["i"] });
          return;
        }
        if (key === "sysCreateTime") {
          newConditionV2.push({ ...c, key: sysPropMap["h"] });
          return;
        }
        if (key === "sysModifyTime") {
          newConditionV2.push({ ...c, key: sysPropMap["m"] });
          return;
        }
        if (key === "status") {
          newConditionV2.push({ ...c, key: sysPropMap["status"] });
          return;
        }
      });
      const res = await this.query({
        page,
        pageSize,
        condition: newConditionV2,
        orgId,
        thm_id: th_id
      });
      console.log(res);
    });
    __publicField(this, "update", editTableData);
    __publicField(this, "insert", addTableData);
    __publicField(this, "delete", deleteTableData);
    __publicField(this, "getTableHeader", getTableHeader);
    __publicField(this, "getTableHeaderMapList", getTableHeaderMapList);
  }
};
TableHeaderManager = __decorateClass$1([
  injectable(),
  __decorateParam$1(0, inject(CurrentUserManager)),
  __decorateParam$1(1, inject(OrgManager))
], TableHeaderManager);

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __decorateParam = (index, decorator) => (target, key) => decorator(target, key, index);
let PiSDK = class {
  constructor(eventManager, userManager, groupManager, roleManager, departmentManager, orgManager, templateManager, nodeManager, currentUserManager, piConnectionManager, tableHeaderManager) {
    this.eventManager = eventManager;
    this.userManager = userManager;
    this.groupManager = groupManager;
    this.roleManager = roleManager;
    this.departmentManager = departmentManager;
    this.orgManager = orgManager;
    this.templateManager = templateManager;
    this.nodeManager = nodeManager;
    this.currentUserManager = currentUserManager;
    this.piConnectionManager = piConnectionManager;
    this.tableHeaderManager = tableHeaderManager;
  }
  setup({ orgId }) {
    this.eventManager.emit("orgIdUpdate", orgId);
    return this.currentUserManager.updateCurrentUser({ orgId });
  }
  setAuthToken({ ad, token }) {
    registerAuthToken({ ad, token });
  }
  /**
   * 仅调试以及演示使用，生产场景下，请使用 tableHeaderManager.query 查询节点
   */
  async getNodeList(params) {
    console.warn(
      "\u4EC5\u8C03\u8BD5\u4EE5\u53CA\u6F14\u793A\u4F7F\u7528\uFF0C\u751F\u4EA7\u573A\u666F\u4E0B\uFF0C\u8BF7\u4F7F\u7528 tableHeaderManager.query \u67E5\u8BE2\u8282\u70B9"
    );
    const _params = {
      conditionV2: params.condition,
      orgId: params.orgId,
      hardLimit: params.page * params.pageSize,
      orderBy: "createTime",
      orderDesc: true,
      userId: ""
    };
    const list = await getNodeList(_params);
    return list.map(formatMetaDataToNodeData);
  }
  updateNodeProp({ orgId, nodeId, ...rest }) {
    const node = this.piConnectionManager.getPiConnection(orgId).nodeManager.getNode(nodeId);
    return node.updateProp({ ...rest, temp_id: node.tempInfo.id });
  }
};
PiSDK = __decorateClass([
  singleton(),
  __decorateParam(0, inject(EventManager)),
  __decorateParam(1, inject(UserManager)),
  __decorateParam(2, inject(GroupManager)),
  __decorateParam(3, inject(RoleManager)),
  __decorateParam(4, inject(DepartmentManager)),
  __decorateParam(5, inject(OrgManager)),
  __decorateParam(6, inject(TemplateManager)),
  __decorateParam(7, inject(NodeManager)),
  __decorateParam(8, inject(CurrentUserManager)),
  __decorateParam(9, inject(PiConnectionManager)),
  __decorateParam(10, inject(TableHeaderManager))
], PiSDK);
const getPiSDK = () => {
  return container.resolve(PiSDK);
};

export { PiSDK, formatMetaDataToNodeData, getPiSDK };
